import React, { useState } from "react";
import SubmitAction from "../../../components/submitAction/submitAction.js";
import FileUploader from "../fileUploader/fileUploader.js";
import TextInput from "../input/textinput.js";
import IntInput from "../intInput/intInput.js";
import { SelectAndPositionInput, } from "./selectAndPositionInput.js";
import Select from "react-select";
import { selectTheme } from "../select/selectTheme.js";
import ProcessingAnimation from "../ProcessingAnimation/ProcessingAnimation.js";
import BooleanButton from "../button/booleanButton.js";
export default function FormContainer(props) {
    const { isLoading, notify } = props;
    const [inputValues, setInputValues] = useState(Object.fromEntries(props.inputs.map((input) => [input.name, undefined])));
    return (React.createElement(React.Fragment, null,
        React.createElement(SubmitAction, { revertButtonColors: true, message: React.createElement(React.Fragment, null,
                isLoading && React.createElement(ProcessingAnimation, null),
                props.inputs.map((input, index) => {
                    var _a, _b, _c;
                    function onChange(value) {
                        const key = input.name;
                        setInputValues({
                            ...inputValues,
                            [key]: value,
                        });
                    }
                    const lengthValidator = (newValue, errorMessage) => {
                        var _a, _b;
                        if (input.type != "number" && input.type != "text")
                            return [true, "Błąd"];
                        if (((_a = input === null || input === void 0 ? void 0 : input.params) === null || _a === void 0 ? void 0 : _a.maxWidth) &&
                            newValue.length > input.params.maxWidth)
                            return [false, errorMessage];
                        if (((_b = input === null || input === void 0 ? void 0 : input.params) === null || _b === void 0 ? void 0 : _b.minWidth) &&
                            newValue.length < input.params.minWidth)
                            return [false, errorMessage];
                        return [false, ""];
                    };
                    if (input.type === "text") {
                        return (React.createElement(TextInput, { key: index, label: (_a = input.label) !== null && _a !== void 0 ? _a : "", validator: (newValue) => lengthValidator(newValue, "Nieprawidłowa długość"), onChange: onChange, disableExtraSpacing: true }));
                    }
                    if (input.type === "number") {
                        //TODO: add length validation for this type
                        return (React.createElement(IntInput, { key: index, defaultValue: 0, onChange: onChange, label: input.label }));
                    }
                    if (input.type === "file") {
                        return (React.createElement("label", { key: index }, (_b = input.label) !== null && _b !== void 0 ? _b : "",
                            React.createElement(FileUploader, { types: ["image/jpeg", "image/png"], maxSize: 14, key: index, name: "Podaj zdjęcie", onFileError: (err) => {
                                    notify({
                                        time: 6,
                                        children: err,
                                        type: "normal",
                                    });
                                }, onFilesAdded: onChange })));
                    }
                    if (input.type == "selectAndPosition") {
                        return (React.createElement(SelectAndPositionInput, { key: index, params: input.params, onChange: onChange }));
                    }
                    if (input.type === "select") {
                        return (React.createElement(Select, { theme: selectTheme, key: index, options: input.params.options, className: "labeled-select", placeholder: (_c = input.label) !== null && _c !== void 0 ? _c : "", onChange: (newValue) => onChange(newValue) }));
                    }
                    if (input.type === "bool") {
                        return (React.createElement(BooleanButton, { key: index, defaultState: false, label: input.label, onClick: (newVal) => onChange(newVal) }));
                    }
                    return React.createElement(React.Fragment, null, "unknown");
                })), onSubmit: () => {
                props.onSubmit(inputValues);
            }, onReject: () => {
                var _a;
                (_a = props.onReject) === null || _a === void 0 ? void 0 : _a.call(props);
            } })));
}
